import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import type { BusinessSummaryItem } from 'src/features/business/shared/schemas/business-item'
import { CoverPhotoFallback } from 'src/shared/features/users/components/profile-photos/cover-photo'
import MultiProfilePhoto from 'src/shared/features/users/components/profile-photos/multi-profile-photo'

import useSearchMenuActiveStore from '../store/search-menu-active-store'

type BusinessSearchResultItemProps = {
  business: BusinessSummaryItem
}

const BusinessSearchResultItem = ({ business }: BusinessSearchResultItemProps) => {
  const { setIsFocused } = useSearchMenuActiveStore()
  const imageUrl = business.mapSnapshot || undefined
  const teamProfilePhotos = business.teamProfilePhotos || []
  const locationText = business.locationText?.[0] || ''

  const onClick = () => {
    setIsFocused(false)
  }

  return (
    <Link onClick={onClick} to={paths.business.singular.getHref(business.id.toString())} state={{ from: 'search' }}>
      <div className="flex max-w-[180px] cursor-pointer flex-col gap-2">
        <div className="relative h-[110px] w-[180px] shrink-0 overflow-hidden rounded-[12px]">
          <img
            src={imageUrl || CoverPhotoFallback}
            alt=""
            className="size-full rounded-[15px] object-cover sm:rounded-none"
          />
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(180deg, rgba(27, 48, 41, 0.00) 65%, rgba(27, 48, 41, 0.20) 100%)',
            }}
          />
          {teamProfilePhotos.length > 0 && (
            <div className="absolute bottom-[10px] left-[10px]">
              <MultiProfilePhoto profilePhotos={teamProfilePhotos} size={26} className="border-2" />
            </div>
          )}
        </div>
        <div className="flex flex-col items-start gap-0">
          <p className="line-clamp-1 text-[15px] font-semibold text-primary">
            {[business.consumerFirstName, business.consumerLastName].filter(Boolean).join(' ')}
          </p>
          <p className="line-clamp-1 text-[13px] text-muted">
            {[...(business.badges || []), locationText]?.filter(Boolean).join(' · ')}
          </p>
        </div>
      </div>
    </Link>
  )
}

export default BusinessSearchResultItem
